import React from "react";
import {NavLink} from 'react-router-dom';
import {useHistory} from "react-router"

import Menus from "../../Funlove/Categories/Menus";
import {toggleMenu} from "../../Funlove/Components";
import AppConstants from "../../Config/AppConstants";

function Header(props) {
    let history = useHistory();
    const isShowCategories = () => {
        toggleMenu();
    }

    const handleSubmit = (event) => {

        event.preventDefault();
        let keyword = event.target.keyword.value;
        if (!keyword) {
            history.push('/movies');
            return false
        }

        history.push('/movies?keyword=' + keyword);
    }
    return (
        <>
            <header className="sidebar">
                <div className="container">
                    <div className="logo header-item" style={{marginLeft: 10, margin: 0}}>
                        <NavLink to="/">
                            {AppConstants.pageName}
                        </NavLink>
                    </div>
                    {/*<h1 className="hideTag"> Porn JAV HD Online Sex Videos HD full Streaming Xnxx, JAVHD Xvideos, Pornhub Uncensored Funlove With Full Top 1 Rated And 5 Stars Japanese Porn</h1>*/}
                    {/*<h2 className="hideTag"> Watch JAV Online | Free JAV Japanese Porn | Asian Sex Videos | Funlove</h2>*/}
                    <div className="form-search header-item">
                        <form onSubmit={handleSubmit}>
                            <div className="input-group">
                                <input
                                    type="text"
                                    name="keyword"
                                    className="form-control input-sm keyword"
                                    placeholder="Search..."
                                    autoComplete="off" defaultValue=""
                                />
                                <span className="input-group-btn">
						        	<button className="btn btn-sm btn-search" type='submit' style={{"outline": 0}}>
                                        <span className="glyphicon glyphicon-search"></span>
                                    </button>
                                </span>
                            </div>
                        </form>
                    </div>
                    <div className="header-links header-item">
                        <ul>
                            <li>
                                <NavLink to="/" exact id="home" className={`link-header`}>
                                    <i className="glyphicon glyphicon-home"></i><span>Home</span>
                                </NavLink>

                            </li>
                            <li>
                                <NavLink to="/movies" exact id="movies" className={`link-header`}>
                                    <i className="glyphicon glyphicon-film"></i><span>Movies</span>
                                </NavLink>

                            </li>
                            <li className="dropdown">

                                <a
                                    title="Categories"
                                    onClick={() => isShowCategories()}
                                    id="categories"
                                    className={`link-header`}
                                >
                                    <i className="glyphicon glyphicon-list-alt"></i><span>Categories</span>
                                </a>

                                <Menus/>
                            </li>
                            <li>
                                <NavLink to="/pornstars" id="pornstars" className={`link-header`}>
                                    <i className="glyphicon glyphicon-star"></i><span>Pornstars</span>
                                </NavLink>
                            </li>
                            <li className="thePornDude">
                                <a
                                    href="https://theporndude.com"
                                    id="thePornDude"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={`link-header`}
                                >
                                    <i className="glyphicon glyphicon-link"></i><span>ThePornDude</span>
                                </a>
                            </li>
                            <li className="visible-xs-block copyright">{`© ${AppConstants.pageName}, 2021`}</li>
                        </ul>
                    </div>
                </div>
            </header>

            <div className="header-mobile">
                <span
                    type="button"
                    className="show-sidebar-left"
                    onClick={() => props.isShowMenu()}
                    role="none"
                >
                    <i className="glyphicon glyphicon-menu-hamburger"></i>
                </span>
                <NavLink to="/">
                    {AppConstants.pageName}
                </NavLink>
            </div>
        </>
    )
}

export default Header;
